module.exports = __webpack_public_path__ + "img/home-tips.e1fd2faf.png";